module.exports = __webpack_public_path__ + "img/xcb-subject-mirror10-logo.c8c6cd77.png";